import seoLocale from './seo.locale';

export default {
    ...seoLocale,
    namespace: 'placeguide',
};
